module.exports = __webpack_public_path__ + "img/img_left_nav_cooperate.fd28ca3d.svg";